import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeroSection } from '../components/HeroSection';
import { TrustSignals } from '../components/TrustSignals';
import { DegreeCategoryGrid } from '../components/DegreeCategoryGrid';
import { SEOContentSection } from '../components/SEOContentSection';
import { FAQSection } from '../components/FAQSection';
import { usePageMeta } from '../hooks/usePageMeta';
export function RequestInformationPage() {
  usePageMeta('Request Information | Find Online Degree Programs', 'Tell us about your goals and we will match you with accredited online degree programs that fit your career goals, schedule, and budget.', {
    ogImage: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1200&h=630&fit=crop&q=80',
    ogType: 'website'
  });
  const navigate = useNavigate();
  const [hasNavigated, setHasNavigated] = useState(false);
  const handleSelectionChange = (degreeInterest: string, areaOfStudy: string, specialization: string) => {
    // Only proceed once all three are filled and we haven't navigated already
    if (degreeInterest && areaOfStudy && specialization && !hasNavigated) {
      setHasNavigated(true);
      navigate('/request-information/form', {
        state: {
          degreeInterest,
          areaOfStudy,
          specialization
        }
      });
    }
  };
  return <main className="flex-grow bg-light" data-id="element-2775" data-mp="1cx10ousgtn90">
      <HeroSection onSelectionChange={handleSelectionChange} data-id="element-2776" data-mp="z2qi6v72apbe" />
      <TrustSignals data-id="element-2777" data-mp="13ui06hc5jmpx" />
      <DegreeCategoryGrid data-id="element-2778" data-mp="13v05s4kpfdai" />
      <SEOContentSection data-id="element-2779" data-mp="13v9ulou0jeem" />
      <FAQSection data-id="element-2780" data-mp="13wl0bu70qw8d" />
    </main>;
}